import React from "react";
import { GlobalContainer } from "../../Global/layout";
import { LineHeading } from "../../LineHeading";
import { StyledHeadingh3 } from "../../Global/headings";
import { Col, Row } from "antd";
import { CareseBookContainer, SingleEbook } from "./style";

const CareseBook = ({ data }: any) => {
  return (
    <section className="light">
      <GlobalContainer>
        <LineHeading title={data?.lineHeading} number={data?.lineNumber} />
        <StyledHeadingh3 maxWidth="800px" text={data?.content} />
        <CareseBookContainer>
          <Row gutter={30}>
            {data?.coreSpecialtiesPages?.map((item: any, index: number) => {
              return (
                <Col
                  data-aos="fade-up"
                  key={index}
                  xs={24}
                  sm={24}
                  md={12}
                  lg={12}
                  xl={12}
                >
                  <SingleEbook>
                    <a href={item.link}>
                      <img src={item.featuredImage?.node?.mediaItemUrl} alt={item.featuredImage?.node?.altText} />
                      <h4 dangerouslySetInnerHTML={{ __html: item.title }} />
                    </a>
                  </SingleEbook>
                </Col>
              );
            })}
          </Row>
        </CareseBookContainer>
      </GlobalContainer>
    </section>
  );
};

export default CareseBook;
